import React, { useState } from 'react';
import { BaseButton } from '../../../../components/UI/BaseButton';
import CustomTooltip from '../../../../components/UI/Tooltip/CustomTooltip';

export interface ToolbarButtonProps {
  title: string;
  onClick: (e: React.MouseEvent) => void;
  active?: boolean;
  icon: React.ReactNode;
  isLinkMenu?: boolean;
  closeTooltipOnClick?: boolean;
}

const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  title,
  onClick,
  active,
  icon,
  isLinkMenu,
  closeTooltipOnClick = false,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    if (closeTooltipOnClick) {
      // Close tooltip immediately on click
      setTooltipOpen(false);
    }
    // Execute the original onClick
    onClick(e);
  };

  // Use controlled tooltip only when closeTooltipOnClick is true
  const tooltipProps = closeTooltipOnClick ? { open: tooltipOpen, onOpenChange: setTooltipOpen } : {};

  return (
    <CustomTooltip title={title} {...tooltipProps}>
      <div className="pointer-events-auto">
        <BaseButton
          onClick={handleClick}
          type="secondary"
          active={active}
          size="small"
          className={`${isLinkMenu ? 'w-1' : 'w-6'}`}
        >
          {icon}
        </BaseButton>
      </div>
    </CustomTooltip>
  );
};

export default ToolbarButton;
